import axios from "axios";
import ThemeMaker from "../../components/thememaker";
import { config } from "../../utils/config";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Link, useParams, useHistory } from "react-router-dom";
import Papa from 'papaparse';
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import * as XLSX from 'xlsx';
import { Select } from "antd";
import { tokenDecode } from "../../utils/helper";


const Sstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: "10px",
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  p: 2,
};
export default function Addroducttype() {
  const { apiEndpoint } = config;
  const history = useHistory();
  const decode = tokenDecode();
  const userObj = Array.isArray(decode?.data?.user) ? decode?.data?.user[0] : (decode?.data?.user || {});
  const seller_id = userObj?.seller_id ?? decode?.data?.seller_id ?? sessionStorage.getItem("seller_id");
  const isSellerAdmin = String(seller_id) === "1" || Number(seller_id) === 1;

  const [isSubmitting, setisSubmitting] = useState(false);
  const params: any = useParams()
  const [categories, setCategories] = useState<any[]>([]);
  const [ptData, setptData] = useState({
    name: "",
    category_id: "",
    fssai: true,
    ondc_protocol: "",
    status: true
  });
  const [nameError, setNameError] = useState<string | boolean>(false);
  const [categoryError, setCategoryError] = useState<boolean>(false);

  const nameRegex = /^[a-zA-Z0-9\s.'-]+$/;

  function validateName(val: string) {
    if (!val || (typeof val === "string" && !val.trim())) {
      setNameError(true);
      return false;
    }
    if (!nameRegex.test(val.trim())) {
      setNameError("invalid");
      return false;
    }
    setNameError(false);
    return true;
  }

  function validateCategory(val: any) {
    if (!val || (typeof val === "string" && !val.trim())) {
      setCategoryError(true);
      return false;
    }
    setCategoryError(false);
    return true;
  }

  async function fetchCategories() {
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/snp/categories/get-category`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        }
      });
      if (data?.status === true || data?.status === 200 || Array.isArray(data?.categories) || Array.isArray(data?.data)) {
        setCategories(data?.categories || data?.data || []);
      }
    } catch (error) {
      console.log("Error fetching categories:", error);
    }
  }

  useEffect(() => {
    fetchCategories();
  }, []);

  useEffect(() => {
    if (params?.id) {
      getProductTypeById();
    } else {
      setptData({
        name: "",
        category_id: "",
        fssai: true,
        ondc_protocol: "",
        status: true
      });
      setNameError(false);
      setCategoryError(false);
    }
  }, [params?.id]);



  const catMapping: any = {
    'Fruits and Vegetables': "",
    'Masala & Seasoning': '@ondc/org/statutory_reqs_packaged_commodities',
    'Oil & Ghee': '@ondc/org/statutory_reqs_packaged_commodities',
    'Eggs, Meat & Fish': '@ondc/org/statutory_reqs_packaged_commodities',
    'Cleaning & Household': '@ondc/org/statutory_reqs_packaged_commodities',
    'Bakery, Cakes & Dairy': '@ondc/org/statutory_reqs_prepackaged_food',
    'Pet Care': '@ondc/org/statutory_reqs_packaged_commodities',
    'Stationery': '@ondc/org/statutory_reqs_packaged_commodities',
    'Dairy and Cheese': '@ondc/org/statutory_reqs_prepackaged_food',
    'Snacks, Dry Fruits, Nuts': '@ondc/org/statutory_reqs_prepackaged_food',
    'Pasta, Soup and Noodles': '@ondc/org/statutory_reqs_packaged_commodities',
    'Cereals and Breakfast': '@ondc/org/statutory_reqs_prepackaged_food',
    'Sauces, Spreads and Dips': '@ondc/org/statutory_reqs_prepackaged_food',
    'Chocolates and Biscuits': '@ondc/org/statutory_reqs_prepackaged_food',
    'Cooking and Baking Needs': '@ondc/org/statutory_reqs_packaged_commodities',
    'Tinned and Processed Food': '@ondc/org/statutory_reqs_prepackaged_food',
    'Atta, Flours and Sooji': '@ondc/org/statutory_reqs_packaged_commodities',
    'Rice and Rice Products': '@ondc/org/statutory_reqs_packaged_commodities',
    'Dals and Pulses': '@ondc/org/statutory_reqs_packaged_commodities',
    'Salt, Sugar and Jaggery': '@ondc/org/statutory_reqs_packaged_commodities',
    'Energy and Soft Drinks': '@ondc/org/statutory_reqs_prepackaged_food',
    'Water': "",
    'Tea and Coffee': '@ondc/org/statutory_reqs_packaged_commodities',
    'Fruit Juices and Fruit Drinks': '@ondc/org/statutory_reqs_prepackaged_food',
    'Snacks and Namkeen': '@ondc/org/statutory_reqs_prepackaged_food',
    'Ready to Cook and Eat': '@ondc/org/statutory_reqs_prepackaged_food',
    'Pickles and Chutney': '@ondc/org/statutory_reqs_prepackaged_food',
    'Indian Sweets': '@ondc/org/statutory_reqs_prepackaged_food',
    'Frozen Vegetables': "",
    'Frozen Snacks': '@ondc/org/statutory_reqs_prepackaged_food',
    'Gift Voucher': "",
    'Fragrance': '',
    'Bath Soaps and Gels': '',
    'Hair Oils, Care, and Styling': '',
    'Shampoos and Conditioners': '',
    'Shaving and Grooming': '',
    'Beard Care and Tools': '',
    'Grooming Tools and Accessories': '',
    'Makeup - Nail Care': '',
    'Makeup - Eyes': '',
    'Makeup - Face': '',
    'Makeup - Lips': '',
    'Makeup - Body': '',
    'Makeup - Remover': '',
    'Makeup - Sets and Kits': '',
    'Makeup - Tools and Brushes': '',
    'Makeup - Kits and Combos': '',
    'Skin Care - Face Cleansers': '',
    'Skin Care - Hand and Feet': '',
    'Body Care - Cleansers': '',
    'Body Care - Moisturizers': '',
    'Body Care - Loofah and Other Tools': '',
    'Body Care - Bath Salt and Additives': '',
    'Hair Care - Shampoo, Oils, Conditioners': '',
    'Skin Care - Lotions, Moisturisers, and Creams': '',
    'Skin Care - Oils and Serums': '',
    'Mobile Phone': '',
    'Smart Watch': '',
    'Headset': '',
    'Laptop': '',
    'Desktop': '',
    'Tablet': '',
    'Keyboard': '',
    'Monitor': '',
    'Mouse': '',
    'Power Bank': '',
    'Earphone': '',
    'True Wireless Stereo (TWS)': '',
    'Adapter': '',
    'Cable': '',
    'Extension Cord': '',
    'Audio Accessories': '',
    'Home Audio': '',
    'Microphone': '',
    'Speaker': '',
    'Vehicle Audio': '',
    'Camcorder': '',
    'Camera': '',
    'Camera Bag': '',
    'Batteries': '',
    'Charger': '',
    'Camera Lens': '',
    'Photo Printer': '',
    'Tripod': '',
    'Camera Accessories': '',
    'UPS': '',
    'Networking Device': '',
    'Printer': '',
    'Printer Accessories': '',
    'Storage Drive': '',
    'Pen Drive': '',
    'Memory Card': '',
    'Computer Component': '',
    'Cooling Pad': '',
    'Docking Station': '',
    'Keyboard Guard': '',
    'Laptop Skin': '',
    'Laptop Stand': '',
    'Mousepad': '',
    'Laptop Bag': '',
    'Screen Protector': '',
    'Computer Accessories': '',
    'Computer Software': '',
    'Ebook Reader': '',
    'Tablet Accessories': '',
    'Gaming Controller': '',
    'Gaming Chair': '',
    'Gaming Accessories': '',
    'Gaming Console': '',
    'Video Games': '',
    'Mobile Cover': '',
    'Mobile Mount': '',
    'Mobile Screen Guard': '',
    'Selfie Stick': '',
    'Mobile Skin Sticker': '',
    'Biometrics': '',
    'Home Alarm': '',
    'Home Automation': '',
    'Smart Switch': '',
    'Smart Lighting': '',
    'Home Safe': '',
    'Intercom': '',
    'Sensor': '',
    'Smart TV': '',
    'Standard TV': '',
    'TV Mount': '',
    'Remote': '',
    'Streaming Device': '',
    'TV Accessories': '',
    'Virtual Reality Headset': '',
    '3D Glasses': '',
    '3D Modulator': '',
    'Projector': '',
    'Projector Screen': '',
    'Projector Mount': '',
    'Projector Accessories': '',
    'TV Part': '',
    'TV Remote': '',
    'Set Top Box': '',
    'TV Stand': '',
    'Video Player': '',
    'Digital Photo Frame': '',
    'Home Theatre Projector': '',
    'Video Player Accessories': '',
    'Smart Band': '',
    'Smart Glasses': '',
    'Watch Strap Band': '',
    'Wearable Accessories': '',

    'Air Purifier': '',
    'Dehumidifier': '',
    'Humidifier': '',
    'Air Cleaner Accessories': '',
    'Air Conditioner': '',
    'Air Conditioner Accessories': '',
    'Air Cooler': '',
    'Trimmer': '',
    'Shaver': '',
    'Epilator': '',
    'Hair Straightener': '',
    'Hair Dryer': '',
    'Hair Curler': '',
    'Hair Crimper': '',
    'Electric Brush': '',
    'Electric Iron': '',
    'Electric Sewing Machine': '',
    'Water Heater': '',
    'Heater Cables': '',
    'Air Heater': '',
    'Coffee Maker': '',
    'Beverage Maker': '',
    'Roti Maker': '',
    'Induction Cooktop': '',
    'Sandwich Maker': '',
    'Electric Cooker': '',
    'Electric Kettle': '',
    'Microwave Oven': '',
    'OTG': '',
    'Toaster': '',
    'Electric Air Fryer': '',
    'Cooking Appliance Accessories': '',
    'Coffee Grinder': '',
    'Food Processor': '',
    'Pasta Maker': '',
    'Food Processor Accessories': '',
    'Blender': '',
    'Juicer': '',
    'Mixer Grinder': '',
    'Wet Grinder': '',
    'Dishwasher': '',
    'Dishwasher Accessories': '',
    'Electric Chimney': '',
    'Kitchen Accessories': '',
    'Freezer': '',
    'Refrigerator': '',
    'Refrigerator Accessories': '',
    'Vacuum Cleaner': '',
    'Vacuum Cleaner Parts and Accessories': '',
    'Washing Machine': '',
    'Washing Machine Accessories': '',
    'Water Purifier': '',
    'Water Cooler': '',
    'Water Dispenser': '',
    'Water Purifier Service Kit': '',
    'Water Purifier Filter': '',
    'Water Purifier Candle': '',
    'Water Purifier Pipe': '',
    'Water Purifier Accessories': '',
    'Water Cooler Accessories': '',
    'Inverter': '',
    'Inverter Batteries': '',
    'Battery Tray': '',
    'Voltage Stabilizer': ''

  }

  function changeHandler(e: any) {
    const { name, value, type, checked } = e.target;
    if (name === "status") {
      setptData((prev) => ({ ...prev, status: checked }));
    } else if (name === "fssai") {
      setptData((prev) => ({ ...prev, fssai: value === "true" }));
    } else {
      setptData((prev) => ({ ...prev, [name]: value }));
      if (name === "name") {
        validateName(value);
      }
    }
  }

  async function submitHandler() {
    const isNameValid = validateName(ptData.name);
    const isCatValid = validateCategory(ptData.category_id);

    const trimmedName = (ptData.name || "").trim();
    if (!isNameValid) {
      if (!trimmedName) {
        toast.error("Product Type Name is required!");
      } else {
        toast.error("Special characters are not allowed in name !");
      }
      return;
    }

    if (!isCatValid) {
      toast.error("Category is required!");
      return;
    }

    try {
      setisSubmitting(true);
      const catId = ptData.category_id
        ? (isNaN(Number(ptData.category_id)) ? ptData.category_id : Number(ptData.category_id))
        : "";

      const payload = {
        name: trimmedName,
        fssai: Boolean(ptData.fssai),
        status: Boolean(ptData.status),
        category_id: catId,
        ondc_protocol: ptData.ondc_protocol
      };

      console.log("Submitting Product Type Payload:", payload);

      const { data } = await axios({
        url: `${apiEndpoint}/snp/products/create-type`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
        },
        data: payload
      });

      if (data?.status === 200 || data?.status === true || data?.success) {
        toast.success(data?.message || "Product type created successfully");
        setisSubmitting(false);
        setptData({
          name: "",
          category_id: "",
          fssai: false,
          ondc_protocol: "",
          status: true
        });
        setNameError(false);
        setCategoryError(false);
      } else {
        toast.error(data?.message || "Error In Adding Product Type");
        setisSubmitting(false);
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Error in API");
      setisSubmitting(false);
    }
  }

  async function updateHandler() {
    const isNameValid = validateName(ptData.name);
    const isCatValid = validateCategory(ptData.category_id);

    const trimmedName = (ptData.name || "").trim();
    if (!isNameValid) {
      if (!trimmedName) {
        toast.error("Product Type Name is required!");
      } else {
        toast.error("Special characters are not allowed in name !");
      }
      return;
    }

    if (!isCatValid) {
      toast.error("Category is required!");
      return;
    }

    try {
      setisSubmitting(true);
      const catId = ptData.category_id
        ? (isNaN(Number(ptData.category_id)) ? ptData.category_id : Number(ptData.category_id))
        : "";

      const payload = {
        name: trimmedName,
        fssai: Boolean(ptData.fssai),
        status: Boolean(ptData.status),
        category_id: catId,
        ondc_protocol: ptData.ondc_protocol
      };

      const { data } = await axios({
        url: `${apiEndpoint}/snp/products/update-type/${params.id}`,
        method: "PUT",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
        },
        data: payload
      });

      if (data?.status === 200 || data?.status === true || data?.success) {
        toast.success(data?.message || "Product type updated successfully");
        setisSubmitting(false);
        history.push("/producttypelist");
      } else {
        toast.error(data?.message || "Error In Updating Product Type");
        setisSubmitting(false);
      }
    } catch (err: any) {
      setisSubmitting(false);
      toast.error(err?.response?.data?.message || "Error in API");
    }
  }

  const getSelectedProtocolArray = (protocolValue: any) => {
    if (!protocolValue) return [];
    if (Array.isArray(protocolValue)) return protocolValue;
    if (typeof protocolValue === "string") {
      return protocolValue
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean);
    }
    return [];
  };

  async function getProductTypeById() {
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/snp/products/get-type/${params.id}`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
        }
      });
      console.log("Get Product Type Response:", data);
      if (data?.status === 200 || data?.status === true) {
        const item = Array.isArray(data?.data) ? data?.data[0] : (data?.data || data?.productType);

        if (data?.category && Array.isArray(data.category) && data.category.length > 0) {
          setCategories((prevCategories) => {
            const existingIds = new Set(prevCategories.map((c: any) => String(c.id)));
            const newCats = data.category.filter((c: any) => !existingIds.has(String(c.id)));
            return [...newCats, ...prevCategories];
          });
        }

        if (item) {
          const catId = item?.category_id ?? item?.parent_id ?? data?.category?.[0]?.id ?? "";
          setptData({
            name: item?.name || "",
            category_id: catId !== "" && catId !== null && catId !== undefined ? String(catId) : "",
            fssai: item?.fssai ?? true,
            ondc_protocol: Array.isArray(item?.ondc_protocol)
              ? item.ondc_protocol.join(", ")
              : (item?.ondc_protocol || item?.ondc_mapping || ""),
            status: item?.status ?? true
          });
        }
      } else {
        toast.error(data?.message || "Error In Loading Product Type");
      }
    } catch (err: any) {
      console.log("Error loading product type by ID:", err);
      toast.error(err?.response?.data?.message || "Error loading product type");
    }
  }
  const [shipmentModalOpen, setshipmentModalOpen] = useState(false);
  const [mandatoryAttrModalOpen, setmandatoryAttrModalOpen] = useState(false);
  const [file, setFile] = useState<any>(null);
  const isValidCsvOrExcel = (selectedFile: any) => {
    if (!selectedFile || !selectedFile.name) return false;
    const fileName = selectedFile.name.toLowerCase();
    const validExtensions = [".csv", ".xlsx", ".xls"];
    return validExtensions.some((ext) => fileName.endsWith(ext));
  };

  const handleImport = async () => {
    if (!file) {
      toast.error("Please select a file to import!");
      return;
    }

    if (!isValidCsvOrExcel(file)) {
      toast.error("Invalid file format! Please upload only a CSV or Excel file (.csv, .xlsx, .xls)");
      return;
    }

    try {
      const formData: any = new FormData();
      formData.append("file", file);

      let result = await axios({
        url: `${apiEndpoint}/snp/products/import-product-type`,
        method: 'POST',
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });

      const resData = result?.data;
      if (resData?.status === true || resData?.status === 200 || resData?.success || result?.status === 200) {
        toast.success(resData?.message || "Product Types added successfully!");
        setFile(null);
        setshipmentModalOpen(false);
        let inputelement: any = document.getElementById('inputFile');
        if (inputelement) inputelement.value = '';
      } else {
        toast.error(resData?.message || "Import failed!");
      }
    } catch (error: any) {
      console.log("Import error:", error);
      const errorMessage = error?.response?.data?.message || error?.message || "Error importing product types!";
      toast.error(errorMessage);
    }
  };

  const [mafile, setmaFile] = useState<any>(null);
  const handleMAFileChange = (event: any) => {
    const selectedFile = event.target?.files?.[0];
    console.log("Selected MA file:", selectedFile);
    if (selectedFile) {
      if (!isValidCsvOrExcel(selectedFile)) {
        toast.error("Invalid file format! Please select only a CSV or Excel file (.csv, .xlsx, .xls)");
        event.target.value = "";
        setmaFile(null);
        return;
      }
      setmaFile(selectedFile);
    }
  };
  const handleMAImport = async () => {
    try {
      if (!mafile) {
        toast.error("Please select a file to import!");
        return;
      }
      if (!isValidCsvOrExcel(mafile)) {
        toast.error("Invalid file format! Please upload only a CSV or Excel file (.csv, .xlsx, .xls)");
        return;
      }
      const formData: any = new FormData();
      formData.append("file", mafile);
      console.log("Importing file:", mafile);
      let result = await axios({
        url: `${apiEndpoint}/snp/import-mandatory-attributes`,
        method: 'POST',
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });
      const resData = result?.data;
      if (resData?.status === true || resData?.status === 200 || resData?.success) {
        toast.success(resData?.message || "Imported Successfully!");
        setmandatoryAttrModalOpen(false);
      } else {
        toast.error(resData?.message || "Import failed!");
      }
      console.log("Import result:", result);
    } catch (error: any) {
      console.log("Import error:", error);
      const errorMessage = error?.response?.data?.message || error?.message || "Error importing mandatory attributes!";
      toast.error(errorMessage);
    }
  };

  function handleShipementModalClose() {
    setshipmentModalOpen(false)
  }
  function handleMAModalClose() {
    setmandatoryAttrModalOpen(false)
  }

  async function getSampleCsv() {
    try {
      const token = sessionStorage.getItem('token') || '';
      const response = await axios({
        url: `${apiEndpoint}/snp/products/csv-product-type`,
        method: "POST",
        responseType: "blob",
        headers: {
          "x-custom-authorization": `Bearer ${token}`,
        }
      });

      const data = response?.data;
      const contentType = response.headers?.["content-type"] || "";

      // If backend actually sent a JSON error, it still arrives as a Blob
      // (because responseType is "blob") — detect and surface the real message.
      if (contentType.includes("application/json")) {
        const text = await data.text();
        const parsed = JSON.parse(text);
        throw new Error(parsed?.message || parsed?.error || "Failed to fetch sample file.");
      }

      // Real binary file response (xlsx / csv)
      if (data instanceof Blob && data.size > 0) {
        const isXlsx =
          contentType.includes("spreadsheetml") ||
          contentType.includes("xlsx") ||
          contentType.includes("vnd.ms-excel");

        const extension = isXlsx ? "xlsx" : "csv";
        const mimeType = isXlsx
          ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          : "text/csv;charset=utf-8;";

        const blob = new Blob([data], { type: mimeType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Sample_Product_Type_${new Date().getTime()}.${extension}`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        toast.success("Sample file downloaded successfully!");
        return;
      }

      // Empty/unexpected response — fall back to default template
      downloadDefaultSample();
    } catch (err: any) {
      console.log("getSampleCsv error, falling back to default template:", err);
      downloadDefaultSample();
    }
  }

  function downloadDefaultSample() {
    const defaultSample = [
      {
        "product_type_name": "Bakery, Cakes & Dairy",
        "category_id": "EB2B",
        "ondc_protocol": "ONDC:RET10",
        "fssai": "true",
        "status": "true",
        "is_mandatory": "true",
        "product_type_attribute": "Flavour"
      }
    ];
    const headers = Object.keys(defaultSample[0]);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(defaultSample, { header: headers });
    XLSX.utils.book_append_sheet(wb, ws, 'ProductTypes');
    const fileName = `Sample_Product_Type_${new Date().getTime()}.csv`;
    XLSX.writeFile(wb, fileName);
    toast.success("Sample CSV downloaded successfully!");
  }

  async function getSampleMandatoryAttrCsv() {
    try {
      const defaultSample = [
        {
          "product_type_name": "Bakery, Cakes & Dairy",
          "category_id": "EB2B",
          "is_mandatory": "true",
          "product_type_attribute": "Flavour"
        },
        {
          "product_type_name": "Bakery, Cakes & Dairy",
          "category_id": "EB2B",
          "is_mandatory": "true",
          "product_type_attribute": "Weight"
        }
      ];
      const headers = Object.keys(defaultSample[0]);
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(defaultSample, { header: headers });
      XLSX.utils.book_append_sheet(wb, ws, 'MandatoryAttributes');
      const fileName = `Sample_Mandatory_Attributes_${new Date().getTime()}.csv`;
      XLSX.writeFile(wb, fileName);
      toast.success("Sample CSV downloaded successfully!");
    } catch (err: any) {
      console.log("Error generating sample mandatory attributes CSV:", err);
      toast.error("Failed to download sample CSV");
    }
  }

  return (
    <ThemeMaker>
      <div className="row w-100 m-0 mt-1">
        <div className="col-md-12 ">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold  text-left d-flex justify-content-between align-items-center" style={{ color: "#0F172A", fontSize: "24px" }}>
                {params?.id ? "Update Product Type" : "Add Product Type"}
                <div className="d-flex" style={{ gap: "20px" }}>

                  {!params?.id && (
                    <>
                      <button className="text-center btn btn-secondary" onClick={() => {
                        setmandatoryAttrModalOpen(true)
                      }}>Import Madatory Attributes</button>

                      <button className="text-center btn btn-secondary" onClick={() => {
                        setshipmentModalOpen(true)
                      }}>Import</button>
                    </>
                  )}

                  <Link to="/producttypelist" >
                    <button className="btn btn-primary">Product Type List</button>
                  </Link>
                </div>



              </h6>
            </div>

            <div className="card-body" style={{ minHeight: "70vh" }}>

              <div className="row">

                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      Name
                      <span className="text-danger"> * </span>
                      {nameError === true && (
                        <span className="text-danger tiny_size"> This field is required ! </span>
                      )}
                      {nameError === "invalid" && (
                        <span className="text-danger tiny_size"> Special characters are not allowed in name ! </span>
                      )}
                    </label>
                    <input
                      type="text"
                      name="name"
                      value={ptData.name}
                      className="form-control"
                      placeholder="Enter Product Type Name"
                      onChange={changeHandler}
                      onBlur={(e) => validateName(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      Category
                      <span className="text-danger"> * </span>
                      {categoryError && (
                        <span className="text-danger tiny_size"> Please select a category ! </span>
                      )}
                    </label>
                    <Select
                      showSearch
                      style={{ width: "100%" }}
                      placeholder="Select Category"
                      value={ptData.category_id ? String(ptData.category_id) : undefined}
                      status={categoryError ? "error" : undefined}
                      optionFilterProp="children"
                      filterOption={(input: string, option: any) =>
                        (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                      }
                      onChange={(value) => {
                        setptData((prev) => ({ ...prev, category_id: String(value) }));
                        validateCategory(value);
                      }}
                    >
                      {categories.map((item: any) => (
                        <Select.Option key={String(item.id)} value={String(item.id)}>
                          {item.name || item.cat_name}
                        </Select.Option>
                      ))}
                    </Select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label>FSSAI Required</label>
                    <select
                      name="fssai"
                      value={String(ptData.fssai)}
                      className="form-control"
                      onChange={changeHandler}
                    >
                      <option value="true">Yes </option>
                      <option value="false">No </option>
                    </select>
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="form-group">
                    <label>ONDC Protocol</label>
                    <Select
                      mode="multiple"
                      allowClear
                      style={{ width: "100%" }}
                      placeholder="Select ONDC Protocol"
                      value={getSelectedProtocolArray(ptData.ondc_protocol)}
                      onChange={(values: string[]) => {
                        setptData((prev) => ({
                          ...prev,
                          ondc_protocol: Array.isArray(values) ? values.join(", ") : ""
                        }));
                      }}
                      options={[
                        {
                          label: "@ondc/org/statutory_reqs_prepackaged_food",
                          value: "@ondc/org/statutory_reqs_prepackaged_food"
                        },
                        {
                          label: "@ondc/org/statutory_reqs_packaged_commodities",
                          value: "@ondc/org/statutory_reqs_packaged_commodities"
                        }
                      ]}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group d-flex align-items-center" style={{ gap: "10px" }}>
                    <label className="m-0">Status</label>
                    <input
                      type="checkbox"
                      name="status"
                      checked={ptData.status}
                      onChange={changeHandler}
                    />
                  </div>
                </div>

                <div className="col-md-12 mt-3">

                  {params.id === undefined ? <button className="btn btn-primary" onClick={submitHandler} >{isSubmitting ? "Please Wait" : "Submit"}</button> : <button className="btn btn-success" onClick={updateHandler} >{isSubmitting ? "Please Wait" : "Update"}</button>}

                </div>
              </div>
            </div>
          </div>
        </div>

        <>
          {/*  <Modal
            open={shipmentModalOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={Sstyle} className="col-md-4 w-100 w-md-25">
              <div className="modal-content ">
                <div className="modal-header p-2 d-flex align-items-center justify-content-between">
                  <p className="modal-title genericlabel  " style={{ letterSpacing: "1px" }}>Import Using Excel File..</p>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleShipementModalClose} /></span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="importingSection">
                    <input type="file" id="inputFile" onChange={(e: any) => {
                      setFile(e.target.files[0]);
                    }} />


                  </div>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-primary" onClick={handleImport} > Submit </button>
                </div>
              </div>
            </Box>
          </Modal>
*/}
          <Modal
            open={shipmentModalOpen}
            // onClose={handleShipementModalClose}  
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={Sstyle} className="col-md-4 w-100 w-md-25">

              <div className="modal-content ">
                <div className="modal-header p-2 d-flex align-items-center justify-content-between">
                  <p className="modal-title genericlabel  " style={{ letterSpacing: "1px" }}>Import Using Excel File..
                    <span className="text-primary ml-2" style={{ cursor: "pointer" }} onClick={getSampleCsv}>Download Sample CSV</span></p>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleShipementModalClose} /></span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="importingSection">
                    <input
                      type="file"
                      id="inputFile"
                      accept=".csv, .xlsx, .xls"
                      onChange={(e: any) => {
                        const selectedFile = e.target.files?.[0];
                        if (selectedFile) {
                          if (!isValidCsvOrExcel(selectedFile)) {
                            toast.error("Invalid file format! Please select only a CSV or Excel file (.csv, .xlsx, .xls)");
                            e.target.value = "";
                            setFile(null);
                            return;
                          }
                          setFile(selectedFile);
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-primary" onClick={handleImport} > Submit </button>
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={mandatoryAttrModalOpen}
            // onClose={handleShipementModalClose}  
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={Sstyle} className="col-md-4 w-100 w-md-25">

              <div className="modal-content ">
                <div className="modal-header p-2 d-flex align-items-center justify-content-between">
                  <p className="modal-title genericlabel  " style={{ letterSpacing: "1px" }}>Import Using CSV File..

                  </p>
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleMAModalClose} /></span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="importingSection">
                    <input
                      type="file"
                      id="maInputFile"
                      accept=".csv, .xlsx, .xls"
                      onChange={(e: any) => {
                        handleMAFileChange(e);
                      }}
                    />


                  </div>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-primary" onClick={handleMAImport} > Submit </button>
                </div>
              </div>
            </Box>
          </Modal>
        </>
      </div>

    </ThemeMaker>
  )
}
